var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDarkGrey32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90909 24.4C4.51574 24.4 5.81818 25.6536 5.81818 27.2C5.81818 28.7464 4.51574 30 2.90909 30C1.30244 30 0 28.7464 0 27.2C0 25.6536 1.30244 24.4 2.90909 24.4Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90909 13.2C4.51574 13.2 5.81818 14.4536 5.81818 16C5.81818 17.5464 4.51574 18.8 2.90909 18.8C1.30244 18.8 0 17.5464 0 16C0 14.4536 1.30244 13.2 2.90909 13.2Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5455 15C31.3488 15 32 15.2268 32 16C32 16.7732 31.3488 17 30.5455 17H20.5H10.1818C9.37849 17 8.72727 16.7732 8.72727 16C8.72727 15.2268 9.37849 15 10.1818 15H20.5H30.5455Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90909 2C4.51574 2 5.81818 3.2536 5.81818 4.8C5.81818 6.3464 4.51574 7.6 2.90909 7.6C1.30244 7.6 0 6.3464 0 4.8C0 3.2536 1.30244 2 2.90909 2Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5455 4C31.3488 4 32 4.2268 32 5C32 5.7732 31.3488 6 30.5455 6H20.5H10.1818C9.37849 6 8.72727 5.7732 8.72727 5C8.72727 4.2268 9.37849 4 10.1818 4H20.5H30.5455Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5455 26C31.3488 26 32 26.2268 32 27C32 27.7732 31.3488 28 30.5455 28H20.5H10.1818C9.37849 28 8.72727 27.7732 8.72727 27C8.72727 26.2268 9.37849 26 10.1818 26H20.5H30.5455Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDarkGrey32);
export default __webpack_public_path__ + "static/media/menu_dark_grey32.0203f554ab419dad0a465a283812389d.svg";
export { ForwardRef as ReactComponent };